import {LOCALES, GREEK_LANGUAGE_REGEX} from 'providers/ferries/autocompleteResultsBasedOnTypedLanguage/constants';
import {localeFull} from 'helpers/stableValues';

export const isGreekText = (term) => GREEK_LANGUAGE_REGEX.test(term?.trim());

export const isUserLocaleGreekOrEnglish = () => LOCALES.includes(localeFull);

export const getResultsBasedOnTypedLanguage = ({term, listOfTerms}) => {
  if (!isUserLocaleGreekOrEnglish()) {
    return listOfTerms;
  }


  return listOfTerms.filter((item) =>
    (isGreekText(term) && isGreekText(item.plaintext)) ||
    (!isGreekText(term) && !isGreekText(item.plaintext))
  );
};
